<template>
    <el-select v-model="val" @change="handleChange">
        <el-option v-for="item in options" :key="item.uuid" :label="item.name" :value="item.uuid"> </el-option>
    </el-select>
</template>

<script>
import { list } from "@/api/proxy/level";
export default {
    props: {
        value: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            val: "",
            options: [],
        };
    },
    watch: {
        value: {
            handler(val) {
                this.val = val;
            },
            immediate: true,
        },
    },
    mounted() {
        this.search();
    },
    methods: {
        search() {
            list({
                page_index: 1,
                page_size: 9999,
            }).then(({ code, result, error }) => {
                if (code === 200) {
                    this.options = result.data;
                    this.$emit("change", this.options);
                } else {
                    this.$message.error(error.message);
                }
            });
        },
        handleChange(val) {
            this.$emit("input", val);
            this.$emit("change", this.options);
        },
    },
};
</script>

<style></style>
